import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React from 'react';
import { Tooltip } from 'reactstrap';
import { withTranslation } from 'react-i18next';

var ButtonItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ButtonItem, _React$Component);

  var _super = _createSuper(ButtonItem);

  function ButtonItem(props) {
    var _this;

    _classCallCheck(this, ButtonItem);

    _this = _super.call(this, props);

    _this.toggle = function () {
      var disabled = _this.props.disabled;
      if (disabled) return;
      var _this$state = _this.state,
          isFreezed = _this$state.isFreezed,
          tooltipOpen = _this$state.tooltipOpen;
      if (isFreezed && !tooltipOpen) return;

      _this.setState({
        tooltipOpen: !tooltipOpen,
        isFreezed: true
      });

      _this.timer = setTimeout(function () {
        _this.setState({
          isFreezed: false
        });
      }, 100);
    };

    _this.onClick = function (event) {
      if (!_this.props.disabled) {
        _this.props.onClick && _this.props.onClick(event);
      }
    };

    _this.onMouseDown = function (event) {
      if (!_this.props.disabled) {
        _this.props.onMouseDown(event);
      }
    };

    _this.getClassName = function () {
      var _this$props = _this.props,
          isRichEditor = _this$props.isRichEditor,
          className = _this$props.className,
          disabled = _this$props.disabled;
      var itemClass = 'btn btn-icon btn-secondary btn-active';
      if (!isRichEditor) return itemClass + ' ' + className;
      itemClass = "rich-icon-btn ".concat(disabled ? 'rich-icon-btn-disabled' : 'rich-icon-btn-hover');
      return itemClass + ' ' + className;
    };

    _this.state = {
      tooltipOpen: false,
      isFreezed: false
    };
    return _this;
  }

  _createClass(ButtonItem, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.timer && clearTimeout(this.timer);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps, nextState) {
      var disabled = nextProps.disabled,
          isActive = nextProps.isActive;
      var _this$props2 = this.props,
          oldDisabled = _this$props2.disabled,
          oldIsActive = _this$props2.isActive;

      if (disabled !== oldDisabled) {
        this.setState({
          tooltipOpen: false
        });
        return true;
      } // only render iconButton when the button is active or show show tooltip


      var tooltipOpen = nextState.tooltipOpen;
      var oldTooltipOpen = this.state.tooltipOpen;

      if (tooltipOpen === oldTooltipOpen && isActive === oldIsActive) {
        return false;
      }

      return true;
    }
  }, {
    key: "render",
    value: function render() {
      var tooltipOpen = this.state.tooltipOpen;
      var _this$props3 = this.props,
          id = _this$props3.id,
          isActive = _this$props3.isActive,
          disabled = _this$props3.disabled,
          icon = _this$props3.icon,
          text = _this$props3.text;
      var className = this.getClassName();
      var delay = {
        show: 0,
        hide: 0
      };
      return /*#__PURE__*/React.createElement("button", {
        type: "button",
        id: id,
        className: className,
        "data-active": isActive,
        disabled: disabled,
        onClick: this.onClick,
        onMouseDown: this.onMouseDown
      }, /*#__PURE__*/React.createElement("i", {
        className: icon
      }), /*#__PURE__*/React.createElement(Tooltip, {
        target: id,
        isOpen: tooltipOpen,
        delay: delay,
        placement: "bottom",
        toggle: this.toggle
      }, text));
    }
  }]);

  return ButtonItem;
}(React.Component);

ButtonItem.defaultProps = {
  className: '',
  isActive: false
};
export default withTranslation('seafile-editor')(ButtonItem);